import Vue from 'vue';
import axios from '@/axios';
import router from '@/router';

export default {
    login: ({ commit, dispatch, state }, formData) => {
        return new Promise((resolve, reject) => {
            axios.post('accounts/obtain-token/', {
                'username': formData.username,
                'password': formData.password,
            }).then(response => {
                if (!response.data.password_change_url) {
                    window.localStorage.setItem('token', response.data.token);
                    axios.defaults.headers.common['Authorization'] = `Token ${response.data.token}`;
                    commit('SET_USER', response.data.user);
                    if (state.language !== response.data.user.language) {
                        dispatch('toggleLanguage');
                    }

                    let store = null;
                    if (response.data.user.stores.length > 0) {
                        if (!state.activeStore || !response.data.user.stores.some(s => s.id === state.activeStore.id)) {
                            store = response.data.user.stores[0];
                        } else {
                            store = state.activeStore;
                        }
                    }

                    dispatch('updateActiveStore', store);

                }
                resolve(response);
            }).catch(err => {
                reject(err);
            });
        });
    },
    logout: ({ dispatch, commit }) => {
        commit('SET_BUSY', true);
        return new Promise(resolve => {
            axios.delete('accounts/logout/', {}).then(response => {
                commit('SET_BUSY', false);
                commit('SET_LAST_ROUTE', null);
                dispatch('resetUser');
                resolve(response);
            });
            axios.cache.clear();
        });
    },
    loadMenuElements: ({ commit }) => {
        axios.get('api/menu/').then(r => {
            commit('SET_MENU_ITEMS', r.data);
        });
    },
    toggleLanguage ({ dispatch }, commit = true) {
        let language = Vue.config.language === 'fr_CA' ? 'en_CA' : 'fr_CA';
        let shortLanguage = language.split('_')[0];

        dispatch('updateLanguage', shortLanguage);
        Vue.config.language = language;
        dispatch('loadMenuElements');

        if (commit) {
            window.localStorage.setItem('language', shortLanguage);
        }
    },
    resetUser: ({ commit, state }) => {
        if (!state.isRouterBusy) {
            router.push({ name: `Login-${state.language}` });
            commit('SET_IS_ROUTER_BUSY', true);
            commit('SET_USER', null);
            delete axios.defaults.headers.common['Authorization'];
            delete axios.defaults.headers.common['Active-Store'];
            window.localStorage.removeItem('token');
            window.localStorage.removeItem('user');
            commit('SET_IS_ROUTER_BUSY', false);
        }
    },
    updateActiveStore: ({ commit }, payload) => {
        axios.defaults.headers.common['Active-Store'] = payload.id;
        commit('UPDATE_ACTIVE_STORE', payload);
    },
    updateLanguage: ({ commit }, payload) => {
        if (['fr', 'en'].indexOf(payload) === -1) {
            payload = 'en';
        }

        let baseUrl = `${CMS_URL}/${payload}/`;
        axios.defaults.baseURL = baseUrl;

        commit('UPDATE_BASE_URL', baseUrl);
        commit('UPDATE_LANGUAGE', payload);
    },
    loadNotificationCount: ({ commit }) => {
        axios.get('api/notifications/unread/', { params: { 'timestamp': new Date().getTime() }}).then(r => commit('SET_NOTIFICATION_COUNT', r.data.count));
    }
};



// WEBPACK FOOTER //
// ./src/store/bmr/actions.js